import { createApp, reactive } from "vue";
import { VueSignalR } from "@dreamonkey/vue-signalr";
import { HubConnectionBuilder } from "@microsoft/signalr";
import App from "./App.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "../../../icons.base";
import { VueQueryPlugin } from "@tanstack/vue-query";
import router from "./router/router";
import "../global.css";

// Create SignalR connection
const connection = new HubConnectionBuilder().withUrl("/api").build();

export const customer = reactive({
  name: "",
});

const app = createApp(App);

app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 0,
      },
    },
  },
});

app.use(router);
app.use(VueSignalR, {
  autoOffInsideComponentScope: true,
  failFn: (error: Error) => {
    console.error("SignalR connection failed:", error);
  },
  connection,
});
app.component("font-awesome-icon", FontAwesomeIcon);

router.isReady().then(() => {
  app.mount("#app");
});
